// extracted by mini-css-extract-plugin
export default {"container":"SubscribersAddArea_container__WTFs-","saveButton":"SubscribersAddArea_saveButton__adDBG","textArea":"SubscribersAddArea_textArea__JlcYS"};